import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { Reservation } from '../../models/Reservation'
import { BUSINESS_RESERVATIONS_URL } from '../../utils/urls'

/**
 * The business reservations index, separate from the global
 * `services/ReservationService` on purpose: GET /reservations authorizes
 * `list reservation` - every reservation of every venue - which the business
 * role does not hold and must not be given. This endpoint is
 * MANAGE_BUSINESS-gated and pins the `is_business` scope server-side, so the
 * caller no longer declares it.
 */
const fetchReservations = (params: TableParams) =>
  SBAPI.FetchPaginated<Reservation[]>(BUSINESS_RESERVATIONS_URL, params)

export { fetchReservations }
